<template>
  <div id="app">
    <YsgfAuthPage />
    <!-- <Wakeup /> -->
    <!-- <Specail /> -->
    <!-- <EnterShop /> -->
    <!-- <Zhuanti /> -->
    <!-- <LotterySharePage/> -->
  </div>
</template>

<script>

// import HomePage from './components/HomePage.vue'
// import HomePage from './components/Redirect.vue'
// import DownloadPage from './components/Download.vue'
// import SharePage from './components/SharePage.vue'
// import JBZCertPage from './components/JBZCertPage.vue'

// import ZhuLiPage from './components/ZhuLiPage.vue'
// import LotterySharePage from './components/LotterySharePage.vue'

// import Zhuanti from './components/Zhuanti.vue'
// import EnterShop from './components/EnterShop.vue'
// import Specail from './components/Special.vue'
// import Wakeup from './components/Wakeup.vue'
import YsgfAuthPage from './components/YsgfAuthPage.vue'

export default {
  name: 'App',
  components: {
    // LotterySharePage
    // DownloadPage
    // JBZCertPage
    // Zhuanti
    // EnterShop
    // Specail
    // Wakeup
    YsgfAuthPage
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.van-image {
  padding: 0.7rem;
}
.van-field__label {
  width: 5rem;
}
.van-button {
  height: 3rem;
}
.van-button--normal {
  font-size: 1.5rem;
  /* color: #323233 !important; */
}
.van-grid-item__content {
  padding: 0.3rem;
}
.van-cell {
  font-size: 1.2rem;
  background-color: #cddeba;
}
.van-cell:not(:last-child)::after {
  border-bottom: 0;
}
.van-cell {
  border-bottom: 1px solid #4b8354;
}
.bold {
  font-weight: bold;
}
</style>
